import { Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';
import { ApiHttp } from 'app/providers';

@Injectable()
export class ChatService {
    constructor(private apiHttp: ApiHttp) {
    }

    public getChat(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/Chat/GetChat', data, messageService);
    }

    public addMessage(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/Chat/AddMessage', data, messageService);
    }

    public markMessagesAsRead(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/Chat/MarkMessagesAsRead', data, messageService);
    }
}
